import { Component, ViewChild, OnInit, AfterViewInit, Input } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad';
import { OnlinesignatureService } from './onlinesignature.service';
import { OnlineSignature } from './onlineSignature.model';
import { ActivatedRoute, Router } from '@angular/router';
import * as ApiConfig from '../core/apiconfig';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TxtAttach } from '../core/index.model';
import { Guid } from '../core/guid';

@Component({
    selector: 'app-online-sign-pad',
    templateUrl: './online-sign-pad.component.html',
    host: { 'class': 'online-sign-pad' },
    styleUrls: ['./online-sign-pad.component.css']
})
export class OnlineSignPadComponent implements OnInit {
    message: string;
    isError: boolean;
    isAlert: boolean;
    showLoading: boolean;
    signnewid: Guid;
    signdata: string;
    isWarning: boolean;
    isAlertSuccess: boolean;
    signpadhidden: boolean;
    stringifiedData: any;
    txtattach: TxtAttach;
    isPDFEnable: boolean = true;
    isDisabled: boolean = false; 
    //signForm: FormGroup;
    //mandateAll: boolean = true;
    //FName: string;
    //LName: string;
    //isNameEnable: boolean;

    @ViewChild(SignaturePad) signaturePad: SignaturePad;
    mobileSignPad: boolean;
    tabSignPad: boolean;
    laptopSignPad: boolean;
    systemSignPad: boolean;

    constructor(private signatureService: OnlinesignatureService,
        private route: ActivatedRoute,
        private fb: FormBuilder,
        private router: Router,) {
        var signImg = ''
        route.params.subscribe(val => {
            let id = (this.route.snapshot.params['signId']) ? this.route.snapshot.params['signId'] : '';
            this.signnewid = id;
        });
    }

    ngOnInit(): void {
        this.isAlertSuccess = false;
        this.signpadhidden = true;
        this.isValidSignature(this.signnewid);
        //this.formGroup();
        if (window.innerWidth < 710) {
            this.mobileSignPad = true;
        }
        else if (window.innerWidth > 711 && window.innerWidth < 800) {
            this.tabSignPad = true;
        }
        else if (window.innerWidth > 1000 && window.innerWidth < 1200) {
            this.laptopSignPad = true;
        }
        else if (window.innerWidth > 1900 && window.innerWidth < 2000) {
            this.systemSignPad = true;
        }
        else {
            this.systemSignPad = true;
        }
    }

    ngAfterViewInit() {
    }
     
    signpadData = {
    SignatureID: null,
    ImageDataJson: ''
   }; 

    private signaturePadOptions: Object = {
        'canvasWidth': window.innerWidth - 65,
    };
    private signaturePadOptionsTab: Object = {
        'canvasWidth': window.innerWidth - 130,
    };
    private signaturePadOptionsLaptop: Object = {
        'canvasWidth': window.innerWidth - 400,
    };
    private signaturePadOptionsSystem: Object = {
        'canvasWidth': window.innerWidth - 1260,
    };

    //formGroup() {
    //    this.signForm = this.fb.group({
    //        firstName: [null,Validators.required],
    //        lastName: [null, Validators.required]
    //    });
    //}

    clearSignature() {
        this.signaturePad.clear();
    }

    isValidSignature(id) {
        if (id != "") {
            //this.FName = "",
            //this.LName = "";
            this.signatureService.getisValidSign(id)
                .then(response => {
                    this.signpadhidden = false;
                    //this.isNameEnable = false;
                    if (response) {
                        //this.FName = response.FName;
                        //this.LName = response.LName;
                        //(this.FName == null && this.LName == null) ? this.isNameEnable = true : this.isNameEnable = false;
                        this.showLoading = true;
                        this.txtattach = response.SignatureFile;
                        if (response.IsValid == true) {
                            this.isDisabled = false;
                            if (response.ImageData != null) {
                                this.signpadhidden = true;
                                //this.isNameEnable = true;
                                this.showAlert("Not Authorized", true, true);
                                console.log("Already Signature Submitted");
                                this.isAlertSuccess = true;
                            }
                            if (response.Custom1) {
                                //if (response.Custom1 == '0') {
                                //    this.isPDFEnable = false;
                                //} else {
                                //    this.isPDFEnable = true;
                                //}
                                response.Custom1 == '0' ? this.isPDFEnable = false : this.isPDFEnable = true;
                            }
                        } else {
                            this.invalidResponse();
                            console.log("Time out", response.IsValid);
                        }                       
                    } else {
                        this.invalidResponse();
                        console.log("Signature ID InValid");
                    }
                }).catch(error => {
                    this.showAlert(error, true);
                    this.showLoading = false;
                });
        } else {
            this.signIDValidate(id);
            console.log("Signature ID InValid in onload");
        }
    }


    signIDValidate(id) {
        if (id == "") {
            this.isDisabled = true;
            this.signpadhidden = true;
            //this.isNameEnable = true;
            this.showAlert("Not Authorized", true, true);

        }
    }

    invalidResponse() {
        this.isDisabled = true;
        //this.isNameEnable = true;
        this.signpadhidden = true;
        this.showAlert("Not Authorized", true, true);
    }

    openAttachment() {
        if (this.txtattach != null && this.txtattach.AttachedFile) {
            let contentType = this.txtattach.MIMEType;
            let byteCharacters = atob(this.txtattach.AttachedFile);

            let byteNumbers = new Array(byteCharacters.length);

            for (var i = 0; i < byteCharacters.length; i++)
                byteNumbers[i] = byteCharacters.charCodeAt(i);

            let byteArray = new Uint8Array(byteNumbers);
            let blob = new Blob([byteArray], { type: contentType });

            //Code for IE browser issue (Blob not working in IE : Refer https://developer.mozilla.org/en-US/docs/Web/API/Blob)
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob);
                return;
            }

            let url = window.URL.createObjectURL(blob);
            window.open(url);
        }
        else {
            this.showAlert("Attachement is unavailable", true, true);
            this.showLoading = false;
        }
    }

    submitSignature() {
            if (!this.isDisabled) {
                if (this.signnewid != "") {
                    //if (this.signForm.controls['firstName'].value != null && this.signForm.controls['lastName'].value ) {
                        if (this.signaturePad.isEmpty()) {
                            this.showAlert("Please provide a signature", true, true);
                        } else {
                            // for signature image 
                            var signImg = this.signaturePad.toDataURL().replace('data:image/png;base64,', '');
                            this.signpadData.SignatureID = this.signnewid;
                            this.signpadData.ImageDataJson = signImg;

                            this.stringifiedData = JSON.stringify(this.signpadData);
                            //if ((this.FName && this.FName.toLowerCase().trim()) == (this.signForm.controls['firstName'].value).toLowerCase().trim() &&
                            //    (this.LName && this.LName.toLowerCase().trim()) == (this.signForm.controls['lastName'].value).toLowerCase().trim()) {
                                this.signatureService.saveSignature(this.stringifiedData)
                                    .then(response => {
                                        if (response) {
                                            this.signdata = response.toString();
                                            this.isAlertSuccess = true;
                                            this.signpadhidden = true;
                                            //this.isNameEnable = true;
                                            this.showAlert("Thank You.", false);
                                        }
                                    })
                                    .catch(error => {
                                        this.showAlert(error, true);
                                        this.showLoading = false;
                                    });
                            //} else {
                            //    this.showAlert("First Name/Last Name doesn't match, Please try again...", true, true);
                            //}
                        }
                    //} else {
                    //    this.showAlert("Please Enter all the mandatory fields", true, true);
                    //}                    
                } else {
                    this.signIDValidate(this.signnewid);
                }
            }
    }

    CloseSuccess() {
        window.close();
    }

    // Show Alert

    showAlert(strMsg: string, isErr: boolean, showWarning: boolean = false) {
        this.isAlert = true;
        this.isError = isErr;
        this.isWarning = showWarning;
        this.message = strMsg;
    }

    // Close Alert

    closeAlert() {
        this.isAlert = false;
    }


}



// WEBPACK FOOTER //
// ./SignClient/app/online-sign-pad/online-sign-pad.component.ts